export interface PrescriptionQuestion {
  id: number;
  question: string;
  description?: string;
  type: 'mood' | 'trope' | 'setting' | 'era' | 'character';
  options: PrescriptionOption[];
}

export interface PrescriptionOption {
  id: string;
  text: string;
  emoji: string;
  points: {
    [key: string]: number; // movieId: points
  };
}

export const PRESCRIPTION_QUESTIONS: PrescriptionQuestion[] = [
  {
    id: 1,
    question: "What's your current mood?",
    description: "Choose the vibe you're feeling right now",
    type: 'mood',
    options: [
      {
        id: 'cozy',
        text: 'Cozy & Comfortable',
        emoji: '☕',
        points: {
          '1': 8, '2': 7, '4': 9, '5': 8, '7': 9
        }
      },
      {
        id: 'romantic',
        text: 'Romantic & Dreamy',
        emoji: '🌟',
        points: {
          '1': 9, '2': 8, '3': 7, '4': 8, '6': 7
        }
      },
      {
        id: 'funny',
        text: 'Funny & Lighthearted',
        emoji: '😂',
        points: {
          '2': 9, '5': 8, '6': 9, '7': 7, '8': 8
        }
      },
      {
        id: 'emotional',
        text: 'Emotional & Deep',
        emoji: '😢',
        points: {
          '1': 7, '3': 9, '5': 7, '8': 7
        }
      },
    ]
  },
  {
    id: 2,
    question: "What's your favorite romcom trope?",
    description: "The classic setups we all love",
    type: 'trope',
    options: [
      {
        id: 'fake-dating',
        text: 'Fake Dating',
        emoji: '🤝',
        points: {
          '6': 9, '8': 8
        }
      },
      {
        id: 'enemies-lovers',
        text: 'Enemies to Lovers',
        emoji: '⚔️',
        points: {
          '6': 8, '8': 7
        }
      },
      {
        id: 'friends-lovers',
        text: 'Friends to Lovers',
        emoji: '❤️',
        points: {
          '2': 9, '4': 8
        }
      },
      {
        id: 'holiday-romance',
        text: 'Holiday Romance',
        emoji: '🎄',
        points: {
          '1': 9, '5': 8, '7': 9
        }
      },
    ]
  },
  {
    id: 3,
    question: "Preferred setting?",
    description: "Where should the love story unfold?",
    type: 'setting',
    options: [
      {
        id: 'city',
        text: 'Big City',
        emoji: '🏙️',
        points: {
          '1': 8, '2': 9, '4': 8, '5': 7
        }
      },
      {
        id: 'small-town',
        text: 'Small Town',
        emoji: '🏡',
        points: {
          '3': 7, '6': 8, '7': 7
        }
      },
      {
        id: 'international',
        text: 'International',
        emoji: '🌍',
        points: {
          '4': 7, '7': 9, '8': 8
        }
      },
      {
        id: 'beach',
        text: 'Beach Resort',
        emoji: '🏝️',
        points: {
          '7': 8, '8': 7
        }
      },
    ]
  },
  {
    id: 4,
    question: "Favorite era?",
    description: "Which decade speaks to your heart?",
    type: 'era',
    options: [
      {
        id: '80s',
        text: '80s Classics',
        emoji: '🕺',
        points: {
          '2': 9
        }
      },
      {
        id: '90s',
        text: '90s Gold',
        emoji: '📼',
        points: {
          '2': 8, '4': 9, '5': 8, '6': 9
        }
      },
      {
        id: '2000s',
        text: '2000s Vibes',
        emoji: '📱',
        points: {
          '1': 9, '3': 8, '5': 7, '7': 8
        }
      },
      {
        id: 'modern',
        text: 'Modern Romcoms',
        emoji: '🎬',
        points: {
          '3': 9, '8': 9
        }
      },
    ]
  },
  {
    id: 5,
    question: "Which character are you?",
    description: "Pick your romcom persona",
    type: 'character',
    options: [
      {
        id: 'hopeless-romantic',
        text: 'Hopeless Romantic',
        emoji: '💖',
        points: {
          '1': 9, '4': 8, '7': 8
        }
      },
      {
        id: 'sarcastic-funny',
        text: 'Sarcastic & Funny',
        emoji: '😏',
        points: {
          '2': 9, '5': 8, '6': 8
        }
      },
      {
        id: 'quirky-creative',
        text: 'Quirky & Creative',
        emoji: '🎨',
        points: {
          '3': 9, '8': 8
        }
      },
      {
        id: 'strong-independent',
        text: 'Strong & Independent',
        emoji: '💪',
        points: {
          '5': 7, '8': 9
        }
      },
    ]
  },
];

// Quiz result messages based on match percentage
export const RESULT_MESSAGES = {
  perfect: {
    title: "Perfect Match! 💖",
    message: "You found your romcom soulmate! This movie was made for you."
  },
  great: {
    title: "Great Match! ✨",
    message: "You'll absolutely love this one. Get ready for a fantastic watch!"
  },
  good: {
    title: "Good Match! 👍",
    message: "This is a solid choice that matches your preferences well."
  },
  decent: {
    title: "Decent Match 🤔",
    message: "Give this one a try - it might surprise you!"
  }
};